import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import Cookies from "js-cookie";

// Import modules
import __rules from "./__helpers/__rules";
import __global from "./__helpers/__global";
import __modal from "./__helpers/__modal";

//Import Api Stores
import logoutDialog from "./dialog/logout";
import authentication from "./authentication";
import profile from "./profile/profile";
import account from "./profile/account";
import livetrades from "./profile/livetrades";
import bankInformation from "./profile/bankInformations";
import countries from "./countries";
import cities from "./cities";
import states from "./states";
import faqs from "./faqs";
import tickets from "./tickets";
import trading from "./trading";
import transactions from "./transactions";
import mam from "./mam";
import mamWallet from "./mamWallet";
import platform from "./platform";
import charts from "./charts";
import accountnumber from "./accountnumber";
import company from "./company";
import register from "./register";
import leverage from "./leverage";
import notifications from "./notifications";
import crypto from "./crypto";
import bank from "./bank";
import deposit from "./deposit";
import withdraw from "./withdraw";
import publicinfo from "./publicinfo";
import agreements from "./agreements";
import panelSwitcher from "./panelSwitcher";
import tradablebonus from "./tradablebonus";
import nominee from "./nominee";

Vue.use(Vuex);

const state = {
  baseUrl: "/",
};

const getters = {};
const mutations = {};
const actions = {};

const plugins = [
  createPersistedState({
    key: "client_panel",
    paths: ["authentication.token"],
    storage: {
      getItem: (key) => Cookies.get(key),
      setItem: (key, value) => {
        try {
          const data = JSON.parse(value);
          if (data?.authentication?.token) {
            Cookies.set(key, value, {
              expires: 1,
              domain: process.env.VUE_APP_DOMAIN_URL || undefined, // undefined for localhost
              secure: process.env.VUE_APP_SECURE === 'true', // Convert string to boolean
              sameSite: process.env.VUE_APP_SAME_SITE === 'None' ? 'None' : 'Lax' // Case-sensitive
            });
          } else {
            Cookies.remove(key, {
              domain: process.env.VUE_APP_DOMAIN_URL || undefined, // undefined for localhost
              secure: process.env.VUE_APP_SECURE === 'true', // Convert string to boolean
              sameSite: process.env.VUE_APP_SAME_SITE === 'None' ? 'None' : 'Lax' // Case-sensitive
            });
          }
        } catch (e) {
          console.error("Failed to persist state", e);
          Cookies.remove(key, {
            domain: process.env.VUE_APP_DOMAIN_URL || undefined, // undefined for localhost
            secure: process.env.VUE_APP_SECURE === 'true', // Convert string to boolean
            sameSite: process.env.VUE_APP_SAME_SITE === 'None' ? 'None' : 'Lax' // Case-sensitive
          });
        }
      },
      removeItem: (key) => Cookies.remove(key, {
        domain: process.env.VUE_APP_DOMAIN_URL || undefined, // undefined for localhost
        secure: process.env.VUE_APP_SECURE === 'true', // Convert string to boolean
        sameSite: process.env.VUE_APP_SAME_SITE === 'None' ? 'None' : 'Lax' // Case-sensitive
      }),
    },
  }),
];

export default new Vuex.Store({
  strict: true,
  state,
  getters,
  mutations,
  actions,
  modules: {
    __global,
    __rules,
    __modal,
    // components start
    logoutDialog,
    authentication,
    profile,
    account,
    livetrades,
    bankInformation,
    countries,
    cities,
    states,
    faqs,
    tickets,
    trading,
    transactions,
    mam,
    mamWallet,
    platform,
    charts,
    accountnumber,
    company,
    register,
    leverage,
    notifications,
    crypto,
    bank,
    deposit,
    withdraw,
    publicinfo,
    agreements,
    panelSwitcher,
    tradablebonus,
    nominee,
  },
  plugins,
});
